import {
  Collapsible,
  EmptyInput,
  ModelDateDMY,
  ModelForm,
  ModelNewNumericInput,
  RadioYesNoInput,
} from '@equifinance/shared';
import { css } from 'styled-components';
import {
  checkInsolvencyIsSettled,
  Insolvency,
  useCreditContext,
} from '../../../../contexts/credit';
import { CreditDetailsRow } from '../CreditDetails';

const collapsibleWrapperCss = css`
  padding: 0;
`.toString();

export default function InsolvencyDebtDetails({ insolvency }: { insolvency: Insolvency }) {
  const { updateInsolvencyItem, credit } = useCreditContext();
  const { errors, warnings } = credit;

  const update = (values: any, disableIncrementUpdateCount: boolean = false) => updateInsolvencyItem(
    values,
    insolvency.id,
    disableIncrementUpdateCount,
  );

  const showMonthlyPayment = insolvency.isEquifax ? insolvency.isSatisfied === false : !insolvency.satisfiedDate;
  if (
    insolvency.ignored
    || !insolvency.consolidationType
    || (insolvency.isEquifax ? checkInsolvencyIsSettled(insolvency) : insolvency.satisfiedDate)
  ) {
    return null;
  }

  return (
    <ModelForm model={insolvency} update={update} errors={errors} warnings={warnings}>
      <Collapsible
        id={`${insolvency.id}-debt-details`}
        title="Debt details"
        level={2}
        bodyCss={collapsibleWrapperCss}
      >
        <CreditDetailsRow>
          {insolvency.isEquifax && (
            <RadioYesNoInput
              label="Is it satisfied?"
              field="isSatisfied"
              disabled={insolvency.consolidationType === 'Full'}
              required
            />
          )}
          {insolvency.isEquifax && insolvency.isSatisfied === true && (
            <ModelDateDMY
              id={insolvency?.id}
              field="satisfiedDate"
              label="Satisfied date"
              showDay
              required
            />
          )}
          {showMonthlyPayment && (
            <ModelNewNumericInput
              required
              label="Monthly payment"
              field="monthlyPayment"
              prefix="£"
              isFixedDecimal
              disabled={insolvency.typeOfJudgement === 'Bankruptcy'}
            />
          )}
          {!insolvency.isEquifax && (
            <EmptyInput />
          )}
        </CreditDetailsRow>
      </Collapsible>
    </ModelForm>
  );
}
